import React from 'react';
import { Ellipse } from 'react-konva';
import { CircleShape as ICircleShape } from '../../../../types';
import { mergeRefs } from '../../../../utils/mergeRef';
import { ShapeCommonProps } from '../../types';
import { useShape } from '../ShapeContext/useShape';

export const CircleShape = React.forwardRef<
  React.ElementRef<typeof Ellipse>,
  ShapeCommonProps
>((commonProps, ref) => {
  const { isHovered, shape, isSelected } = useShape();

  const circleShape = shape as ICircleShape;
  const shapeRef = React.useRef<React.ElementRef<typeof Ellipse>>(null);

  return (
    <Ellipse
      {...commonProps}
      x={circleShape.x}
      y={circleShape.y}
      fill={shape.color}
      stroke={
        !shape.locked && (isHovered || isSelected) ? '#000000' : 'transparent'
      }
      strokeWidth={0.5}
      opacity={shape.locked ? 0.5 : 1}
      ref={mergeRefs([shapeRef, ref])}
      radiusX={circleShape.width}
      radiusY={circleShape.height}
    />
  );
});
